export default "/images/693cafc79416475dd712190911dee531.avif";